import React from 'react'

import CustomDropdown from '../CustomDropdown/CustomDropdown'
import { getEmpresas } from '../../services/localstorage/localstorage.service'

export default class SelectEmpresas extends React.Component {
  state = { empresas: [], selectedEmpresa: '' }

  componentDidMount = () => {
    const { companyId } = this.props
    this._loadEmpresas(companyId)
  }

  componentWillReceiveProps = newProps => {
    const { companyId: newCompanyId } = newProps
    const { companyId: oldCompanyId } = this.props
    if (newCompanyId !== oldCompanyId) {
      this._loadEmpresas(newCompanyId)
    }
  }

  render() {
    const { onChange } = this.props
    const { empresas, selectedEmpresa } = this.state
    return (
      <CustomDropdown
        disabled={this.props.disabled}
        optionLabel="name"
        options={empresas}
        value={selectedEmpresa}
        label="Empresa :"
        filter={true}
        onChange={value => onChange(value)}
      />
    )
  }

  _loadEmpresas = companyId => {
    const empresas = getEmpresas()
    const selectedEmpresa = empresas.find(e => e.id === companyId)
    this.setState({
      empresas,
      selectedEmpresa: selectedEmpresa ? selectedEmpresa : '',
    })
  }
}
